import React from "react";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../redux/selectors";
import { SportAZMenuChunk } from "../Drawers/loader";

const QuickLinksMenu = () => {
  const quickLinkDrawers = useSelector(MenuSelectors.quickLinkDrawers);

  return quickLinkDrawers?.map(menuItem => {
    return (
      <SportAZMenuChunk
        key={menuItem.key}
        item={menuItem?.props.item}
        dataTestId={menuItem.props.dataTestId}
        trackingInfo={menuItem.props.trackingInfo}
      />
    );
  });
};

export default React.memo(QuickLinksMenu);
